


































import {
  MetaVendedorListarDto,
  MetaVendedorService,
} from "@/services/meta-vendedor.service";
import InputMoeda from "@/shared/components/input-moeda.vue";
import Modal from "@/shared/components/modal.vue";
import { maiorQue, requiredValidZero } from "@/shared/validators";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Modal,
    InputMoeda,
  },
})
export default class EditarMetaVendedor extends Vue {
  idMeta: number | null = null;
  nomeUsuario = "";
  qtdPontos: number | null = null;
  valorBonus: number | null = null;
  loading = false;

  rules = {
    qtdPontos: [requiredValidZero(), maiorQue(0)],
    valorBonus: [requiredValidZero()],
  };

  abrir(meta: MetaVendedorListarDto) {
    this.idMeta = meta.idMeta;
    this.nomeUsuario = meta.nomeUsuario;
    this.qtdPontos = meta.qtdPontos;
    this.valorBonus = meta.valorBonus;

    const modal = this.$refs.modal as Modal;
    return modal.open();
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  async salvar() {
    const form = this.$refs.form as any;
    if (!form?.validate() || !this.idMeta) {
      return;
    }

    this.loading = true;
    try {
      await MetaVendedorService.AlteraMeta({
        idMeta: this.idMeta,
        qtdPontos: Number(this.qtdPontos),
        valorBonus: Number(this.valorBonus),
      });

      const modal = this.$refs.modal as Modal;
      modal.close(true);
    } finally {
      this.loading = false;
    }
  }
}
